module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    attrs: {
      "id": "loading-div"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "work-summary"
  }, [_c('div', {
    staticClass: "work-summary__title"
  }, [_c('YearMonthForm', {
    attrs: {
      "minYear": _vm.minYear,
      "defaultYear": _vm.year,
      "defaultMonth": _vm.monthName
    },
    on: {
      "monthSelected": function (selMonthName, selMonthNr) {
        _vm.monthName = selMonthName;
        _vm.monthNr = selMonthNr;
      },
      "yearSelected": function (selYear) {
        _vm.year = selYear;
      },
      "modeSelected": function (selMode) {
        _vm.showDeclaredTime = selMode;
      },
      "placeSelected": function (selPlace) {
        _vm.showPlace = selPlace;
      },
      "archivedSelected": function (selArchived) {
        _vm.showArchived = selArchived;
      }
    }
  }), _vm._v(" "), _c('EmployeeFilter', {
    attrs: {
      "fields": ['area', 'project', 'company']
    },
    on: {
      "params": function (params) { return this$1.employeeParams = params; }
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.showPlace) ? _c('table', {
    staticClass: "table horizontal-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Pracownik")]), _vm._v(" "), _vm._l((_vm.places), function(place) {
    return [(_vm.isPlaceToShow(place, _vm.columns[place.id])) ? _c('th', {
      style: ('background-color:' + _vm.getPlaceColor(place.id))
    }, [_vm._v("\n                                " + _vm._s(place.name) + "\n                            ")]) : _vm._e()]
  }), _vm._v(" "), _c('th', [_c('span', [_vm._v("Razem")])])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.summaries), function(summary) {
    return _c('tr', {
      class: {
        archived: summary.is_archived
      }
    }, [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                            " + _vm._s(summary.name) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.places), function(place) {
      return [(_vm.isPlaceToShow(place, _vm.columns[place.id])) ? _c('td', {
        style: ('background-color:' + _vm.getPlaceColor(place.id, summary))
      }, [(_vm.showDeclaredTime) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[place.id])) + " /\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.planned[place.id])) + "\n                                    ")]) : _c('span', {
        attrs: {
          "title": _vm.displayWorkTime(summary.report[place.id])
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[place.id])) + "\n                                    ")])]) : _vm._e()]
    }), _vm._v(" "), _c('td', {
      class: {
        'insufficient-month': _vm.showDeclaredTime &&
          summary.report_total < summary.planned_total
      }
    }, [(_vm.showDeclaredTime) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report_total)) + " /\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.planned_total)) + "\n                                ")]) : _c('span', {
      attrs: {
        "title": _vm.displayWorkTime(summary.report_total)
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report_total)) + "\n                                ")])])], 2)
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.places), function(place) {
    return [(_vm.isPlaceToShow(place, _vm.columns[place.id])) ? _c('td', {
      style: ('background-color:' + _vm.getPlaceColor(place.id))
    }, [_vm._v("\n                                " + _vm._s(_vm.displayWorkTimeInDecimalHours(_vm.columns[place.id])) + "\n                            ")]) : _vm._e()]
  }), _vm._v(" "), _c('td')], 2)], 2)]) : (_vm.monthNr !== -1) ? _c('table', {
    staticClass: "table horizontal-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Pracownik")]), _vm._v(" "), _vm._l((_vm.daysNo), function(day) {
    return _c('th', {
      class: {
        weekend: _vm.weekend(_vm.year, _vm.monthNr, day)
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.padWithZeroes(day)) + "\n                        ")])
  }), _vm._v(" "), _c('th', [_c('span', [_vm._v("Razem")])])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.summaries), function(summary) {
    return _c('tr', {
      class: {
        insufficient: _vm.insufficient(summary.report_total), archived: summary.is_archived
      }
    }, [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                            " + _vm._s(summary.name) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.daysNo), function(day) {
      return _c('td', {
        class: {
          weekend: _vm.weekend(_vm.year, _vm.monthNr, day),
            'insufficient-day': _vm.insufficientDay(summary, day)
        }
      }, [(_vm.absence(day, summary.absences)) ? [(!summary.report[day]) ? _c('span', [_vm._v("\n                                        U\n                                    ")]) : _c('span', [_vm._v("\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[day])) + " / U\n                                    ")])] : (_vm.showDeclaredTime) ? [(summary.planned[day] || summary.report[day]) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[day])) + " /\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.planned[day])) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[day])) + "\n                                    ")])] : [_c('span', {
        attrs: {
          "title": _vm.displayWorkTime(summary.report[day])
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[day])) + "\n                                    ")])]], 2)
    }), _vm._v(" "), _c('td', {
      class: {
        'insufficient-month': _vm.showDeclaredTime && !_vm.isFutureMonth() &&
          summary.report_total < summary.planned_total
      }
    }, [(_vm.showDeclaredTime && (summary.planned_total || summary.report_total)) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report_total)) + " /\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.planned_total)) + "\n                                ")]) : _c('span', {
      attrs: {
        "title": _vm.displayWorkTime(summary.report_total)
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report_total)) + "\n                                ")])])], 2)
  }), 0)]) : _c('table', {
    staticClass: "table horizontal-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Pracownik")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return _c('th', {
      staticClass: "work-summary-month"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("capitalize")(month)) + "\n                        ")])
  }), _vm._v(" "), _c('th', [_vm._v("Razem")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.summaries), function(summary) {
    return _c('tr', {
      class: {
        archived: summary.is_archived
      }
    }, [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                            " + _vm._s(summary.name) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.monthsNo), function(month) {
      return _c('td', {
        class: {
          insufficient: _vm.insufficient(summary.report[month]),
            'insufficient-day': _vm.insufficientDay(summary, month),
            archived: summary.is_archived
        }
      }, [(_vm.showDeclaredTime && (summary.planned[month] || summary.report[month])) ? _c('span', [_vm._v("\n                                     " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[month])) + " /\n                                     " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.planned[month])) + "\n                                  ")]) : _c('span', {
        attrs: {
          "title": _vm.displayWorkTime(summary.report[month])
        }
      }, [_vm._v("\n                                      " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report[month])) + "\n                                  ")])])
    }), _vm._v(" "), _c('td', {
      class: {
        insufficient: _vm.insufficient(summary.report_total), 'insufficient-month':
          _vm.showDeclaredTime && summary.report_total < summary.planned_total,
          archived: summary.is_archived
      }
    }, [(_vm.showDeclaredTime) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report_total)) + " /\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.planned_total)) + "\n                                ")]) : _c('span', {
      attrs: {
        "title": _vm.displayWorkTime(summary.report_total)
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.displayWorkTimeInDecimalHours(summary.report_total)) + "\n                                ")])])], 2)
  }), 0)])]) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c86f03a!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/WorkSummary.vue
// module id = 1104
// module chunks = 0